import styled, { css } from "styled-components";

export const Row = styled.div<{
  justifyContent?: string;
  alignItems?: string;
  marginLeft?: number;
  marginRight?: number;
  colGap?: number;
  rowGap?: number;
  selected?: boolean;
  selectedBackgroundColor?: string;
  wrap?: string;
  onClick?: (event: any) => void;
}>`
  //margin-bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "flex-start"};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
  column-gap: ${(props) =>
    props.colGap !== undefined ? props.colGap + "px" : "5px"};
  row-gap: ${(props) =>
    props.rowGap !== undefined ? props.rowGap + "px" : "10px"};
  flex-wrap: ${(props) => (props.wrap !== undefined ? props.wrap : "wrap")};
  background-color: ${(props) =>
    props.selected !== undefined &&
    props.selected &&
    props.selectedBackgroundColor !== undefined
      ? props.selectedBackgroundColor
      : "inherit"};
  ${(props) =>
    props.onClick
      ? css`
          &:hover {
            cursor: pointer;
          }
        `
      : null};
  ${(props) =>
    props.marginLeft !== undefined
      ? "margin-left: " + props.marginLeft + "px;"
      : ""}
  ${(props) =>
    props.marginRight !== undefined
      ? "margin-right: " + props.marginRight + "px;"
      : ""}
`;

export const RowHover = styled(Row)`
  border-radius: 8px;
  padding: 10px;
  //background-color: "inherit";
  //column-gap: 10px;

  &:hover {
    background-color: ${(props) => props.theme.surfaceHover} !important;
    transition: 0.2s;
    cursor: pointer;
  }
`;

export const ContainerItemRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Col = styled.div<{
  padding?: number;
  justifyContent?: string;
  alignItems?: string;
  rowGap?: number;
  height?: string;
}>`
  padding: ${(props) =>
    props.padding || props.padding === 0 ? props.padding : 10}px;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "flex-start"};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "auto")};
  row-gap: ${(props) =>
    props.rowGap !== undefined ? props.rowGap + "px" : "12px"};
  ${(props) =>
    props.height !== undefined ? "height: " + props.height + ";" : ""};
`;

export const ContainerMaxWidth = styled(Col)`
  width: 100%;
`;

export const Title = styled.div`
  //margin-bottom: 0px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
